import request from "@/router/axios";

export const imitationData = () => {
  return request({
    url: `/api/bed/record/imitationData`,
    method: "post",
  });
};
export const detail = (clinicNo, wardId) => {
  return request({
    url: `/api/api/bed/detail`,
    method: "get",
    params: {
      clinicNo,
      wardId,
    },
  });
};
export const register = (data) => {
  return request({
    url: `/api/api/bed/register`,
    method: "post",
    data,
  });
};
export const reRegiter = (recordId) => {
  return request({
    url: `/api/bed/record/reRegiter`,
    method: "post",
    params: {
      recordId,
    },
  });
};
export const confirm = (data) => {
  return request({
    url: `/api/api/bed/confirm`,
    method: "post",
    data,
  });
};
export const testMsg = (messageId, idNo) => {
  return request({
    url: `/api/api/bed/task/testMsg`,
    method: "post",
    params: {
      messageId,
      idNo,
    },
  });
};
export const cancel = (recordId) => {
  return request({
    url: `/api/bed/record/cancel`,
    method: "post",
    params: {
      recordId,
    },
  });
};

